/**
 * Typed HTML5 drag payload for dragging vault files between panes (e.g. data
 * room → analysis). Uses a dedicated MIME type so a plain text/plain drag and
 * the vault's internal move-drags never collide with file drops. effectAllowed
 * is left to the drag source: the vault list needs 'move' for its internal
 * moves, plain file sources use 'copy'.
 */
export const VAULT_FILE_DRAG_MIME = 'application/x-gaia-vault-files';

export interface VaultFileDragEntry {
  revisionUid: string;
  /** For user-facing error messages. */
  fileName?: string | null;
}

export function setVaultFileDragData(event: DragEvent, entries: VaultFileDragEntry[]): void {
  event.dataTransfer?.setData(VAULT_FILE_DRAG_MIME, JSON.stringify(entries));
}

export function hasVaultFileDragData(event: DragEvent): boolean {
  return event.dataTransfer?.types.includes(VAULT_FILE_DRAG_MIME) ?? false;
}

export function readVaultFileDragData(event: DragEvent): VaultFileDragEntry[] {
  const raw = event.dataTransfer?.getData(VAULT_FILE_DRAG_MIME);
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (entry): entry is VaultFileDragEntry =>
        typeof entry === 'object' &&
        entry !== null &&
        typeof (entry as VaultFileDragEntry).revisionUid === 'string'
    );
  } catch {
    return [];
  }
}
